<script>
import {mapActions} from "vuex";

export default {
  name: "uConnectSuccessStep",
  methods: {
    ...mapActions("uConnect", ["updateUConnectUserSession"]),
    goToUConnect() {
      localStorage.removeItem('uConnectRegistrationKey');
      window.open(
          `${process.env.VUE_APP_UNIFI_AGENT}#/uconnect/search/results`, "_self"
      );
    },
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        // that.$router.push({ path: "/uconnect" });
      } else {
        // Utils.alert("", res.data.message, "error");
      }
    },
    disableBackButton() {
      history.pushState(null, null, location.href);
      this.onPopStateHandler = () => {
        history.pushState(null, null, location.href);
      };
      window.addEventListener("popstate", this.onPopStateHandler);
    },
    enableBackButton() {
      window.removeEventListener("popstate", this.onPopStateHandler);
    },
    handleBeforeUnload(event) {
        event.preventDefault();
        event.returnValue = "Are you sure you want to leave without saving?";
        localStorage.removeItem("uConnectRegistrationKey");
      }
  },
  mounted() {
    this.disableBackButton();
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    this.enableBackButton();
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  created() {
    window.scrollTo({top : 0, behavior: 'smooth'});
    this.$emit('stepChanged', 4);
    var productCode = this.$route.query.productCode;
    var userId = productCode === 'UCON_STND_FREE' ? this.$store.state.uConnect.userId : this.$route.query.uid;
    this.updateUConnectUserSession({
      params: {
        stripesessionid: this.$route.query.session_id,
        token: this.$route.query.token,
        uid: userId,
        productCode: productCode
      },
      callback: this.callback
    });
  },
}
</script>

<template>
  <div class="plan-selection">
    <el-row type="flex" justify="center" align="middle">
      <el-col :xs="24" :sm="20" :md="16" :lg="12" :xl="10">
        <el-card class="selection-card">
          <el-row :gutter="20">
            <el-col class="container" :span=23>
              <span style="width:100%;height:10px;position:absolute;left:0;top:0;"></span>
              <h1 style="line-height: 50px; font-size: 30px; font-weight: 600">Welcome</h1>
              <h3 style="font-size:14px;line-height:21px;margin-bottom:32px;">Thank you for joining UNIFI Property. Your account has been successfully activated.</h3>
              <div style="width:100%;text-align:center;margin-bottom:40px;">
                <el-button
                              type="primary"
                              size="large"
                              class="sign-in-btn"
                              @click="goToUConnect"
                          >Log in to U-Connect</el-button>
              </div>
              <h3 style="font-size:14px;line-height:21px;margin-bottom:32px;">We look forward to assisting you on your property journey.</h3>
              <p style="font-size:12px;line-height:18px;color:#5f5f5f;margin-bottom:10px;">If you are experiencing any
                technical difficulties, please contact our support team on
                <a class="clear" style="text-decoration:underline;color:#003333;margin-bottom:16px;">
                  <span>team@unifiproperty.com</span>
                </a></p>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="css">
.plan-selection {
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f7fa;
}
.selection-card {
  margin-top: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
}
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.sign-in-btn, .join-btn {
  width: 100%;
  background-color: #003333;
  border-color: #003333;
  border-radius: 5px;
  padding: 15px 0;
  height: max-content;
  font: 500 20px DINosaur-a, sans-serif;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/steps/paymentSteps/uConnectSuccessStep.vue